import React from "react";
import { useContext, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import {
  Divider,
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
  TextField,
} from "@material-ui/core";

import { APIContext } from "../../context";

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  formControl: {
    //padding: theme.spacing(1, 2, 2 , 2),
  },
  TituloForm: {
    textTransform: "Uppercase",
    fontWeight: "600",
    marginBottom: theme.spacing(2),
  },
  SubTituloForm: {
    marginBottom: theme.spacing(2),
  },
  Divider: {
    margin: theme.spacing(3, 0, 3, 0),
    backgroundColor: theme.palette.primary.main,
    height: "2px",
  },
  Input: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.primary.main,
  },
  InputBase: {
    textTransform: "Uppercase",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.secondary.main,
  },
  card: {
    // boxShadow: 'none',
    backgroundColor: "#fff",
    color: theme.palette.secondary.main,
    padding: theme.spacing(2, 2, 2, 2),
    borderColor: "#cccecea3",
    marginBottom: theme.spacing(3),
  },
  containerButton: {
    textAlign: "center",
  },
  buttonCalcular: {
    textTransform: "capitalize",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    lineHeight: "1.5rem",
    letterSpacing: "0.1rem",
    fontSize: "1.2rem",
    color: "#fff",
    float: "right",
  },
}));

export default function Notificaciones() {
  const classes = useStyles();
  const history = useHistory();

  const {
    updateParametros,
    listParametros,
    notificaciones,
    setNotificaciones,
    sendTest,
  } = useContext(APIContext);

  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [enabled, setEnabled] = React.useState(false);

  useEffect(() => {
    listParametros();
  }, []);

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <>
      <Card className={classes.card} variant="outlined">
        <CardContent className={classes.FormBase}>
          <Box display="flex" flexDirection="column" p={0} mt={3}>
            <Box display="flex" flexDirection="row" p={0} my={1}>
              <Box width="280px" mr={2}>
                <Typography variant="h6" color="primary" align="left">
                  Email
                </Typography>
              </Box>
              <Box ml={2} style={{ flex: 1 }}>
                <TextField
                  name="notif_email"
                  value={notificaciones.notif_email}
                  variant="outlined"
                  placeholder="Email"
                  fullWidth
                  size="small"
                  onChange={(e) => {
                    setNotificaciones({
                      ...notificaciones,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  //error={inputError.razon_social}
                  helperText={""}
                />
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" p={0} my={1}>
              <Box width="280px" mr={2}>
                <Typography variant="h6" color="primary" align="left">
                  Contraseña
                </Typography>
              </Box>
              <Box ml={2} style={{ flex: 1 }}>
                <TextField
                  name="notif_password"
                  value={notificaciones.notif_password}
                  variant="outlined"
                  type="password"
                  placeholder="Contraseña"
                  fullWidth
                  size="small"
                  onChange={(e) => {
                    setNotificaciones({
                      ...notificaciones,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  //error={inputError.razon_social}
                  helperText={""}
                />
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" p={0} my={1}>
              <Box width="280px" mr={2}>
                <Typography variant="h6" color="primary" align="left">
                  Servicio
                </Typography>
              </Box>
              <Box ml={2}>
                <TextField
                  name="notif_services"
                  value={notificaciones.notif_services}
                  variant="outlined"
                  placeholder="Servicio"
                  fullWidth
                  size="small"
                  onChange={(e) => {
                    setNotificaciones({
                      ...notificaciones,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  //error={inputError.razon_social}
                  helperText={""}
                />
              </Box>
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              p={0}
              mt={3}
            >
              <Button
                variant="contained"
                color="secondary"
                size="large"
                className={classes.buttonCalcular}
                onClick={async () => {
                  await updateParametros(notificaciones);
                }}
                disableElevation
              >
                Actualizar
              </Button>
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              p={0}
              mt={3}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.buttonCalcular}
                onClick={async () => await sendTest()}
                disableElevation
              >
                Probar envio
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
